export const TOP_BAR_HEIGHT = 70;
export const STICKY_HEADER_HEIGHT = 400;

export const TABLET_BREAKPOINT = 1024;
export const MOBILE_BREAKPOINT = 640;
export const DESKTOP_BREAKPOINT = 1280;
export const MEDIUM_DEVICE_BREAKPOINT = 768;
export const XL_DEVICE_BREAKPOINT = 1440;

// TODO Change when https://bitbucket.org/visitoranalytics/multiapp-dashboard/pull-requests/3548 is merged
// TODO extract all zIndex value from code and add them here
export const Z_INDEX = {
  featureTour: 99999,
  tooltipDefault: 9999,
  modals: 2000,
  userMenu: 1750,
  chat: 1700,
  chatwootWidget: 1650,
  topBar: 999,
  sidebar: 998,
  bodyFloatingElements: 500,
};

export const FEATURE_TOUR_IDS = {
  sidebarContainer: 'sidebar-container',
  goToWebsiteBtn: 'go-to-website-btn',
  userMenu: 'user-menu-btn',
  addWebsiteBtn: 'add-website-btn',
  manageWebsitesBtn: 'manage-websites-btn',
  websiteSelectorBtn: 'website-selector-btn',
  openTourContainerButton: 'feature-tour-button-container',
  pageHeaderContainer: 'feature-tour-page-header-container',
};

/** @deprecated use import from @va/types/report-block */
export enum DataViewOption {
  lineDiagram = 'lineDiagram',
  table = 'table',
  barChart = 'barChart',
  stackedLineDiagram = 'stackedLineDiagram',
  steppedLineDiagram = 'steppedLineDiagram',
  radarDiagram = 'radarDiagram',
  horizontalBarChart = 'horizontalBarChart',
  pieChart = 'pieChart',
  kpi = 'kpi',
  map = 'map',
  card = 'card',
}
